<template>
  <div>
    <timetable :id="group_id" />
  </div>
</template>
<script>
import Timetable from "@/components/Item/Group/Timetable";
export default {
  components: {
    Timetable,
  },
  props: {
    group_id: {
      default: null,
    },
  },
  created() {},
  watch: {
    group_id(val) {},
  },
  name: "conferences",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {};
  },
};
</script>

